<template>
    <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate"  label-width="120px">
        <FormGroup>条件</FormGroup>
        <el-form-item label=" 条件" class="label-required" style="margin-bottom: 0;">
            <div class="mt10">
                <ConditionGroup
                    :data="formData.conditions"
                    :verify="conditionVerifyInfo"
                    @add-condition="addCondition"
                    @toggle-logic="toggleLogic"
                    @remove-condition="removeCondition"
                    @change-item="changeConItem"
                    @check-text="getComparativeValueConfig"
                />
            </div>
        </el-form-item>
        <el-form-item prop="condition"></el-form-item>
    </el-form>
</template>

<script>
    import FormGroup from '../formGroup';
    import ConditionGroup from './conditionGroup';
    import utils from '@/libs/utils.js';
    import {cloneDeep, update} from 'lodash';
    import _ from 'lodash';
    import API from '@/api/intelligent/intelligentManaged/index.js';

    export default {
        name: "ConditionInfo",
        components:{
            FormGroup,
            ConditionGroup,
        },
        props:{
            platId:String,
        },
        inject:['max_num','validFormItem','isEdit','isCopy'],
        data(){
            let _this = this;
            const validCondition = (rule, value, callback) =>{
                let allConditions = _this.getAllConditions(_this.formData.conditions);
                if(allConditions.some(item=>!!this.checkConditionError(item))){
                    callback();
                    // callback(new Error('存在不合法的条件，请检查'));
                }
                callback();
            };
            return {
                formData:{
                    conditions:{},
                },
                rules:{
                    condition:[
                        { required:true, validator: validCondition, trigger: 'change' },
                    ],
                },
                baseCondition:{
                    monitor_data:{
                        id:'',
                        field:'',
                        condition_type:'',
                        range_time_type:'',
                        range_time_n:undefined,
                        range_time_n1:undefined,
                        range_time:[],
                        data_method:'',
                        cost_type: 'cost',
                    },
                    comparative_data:{
                        id:'',
                        field:'',
                        condition_type:'',
                        data_method:'',
                        range_time_type:'',
                        range_time:[],
                        range_time_n:undefined,
                        range_time_n1:undefined,
                        delivery_scene:'',
                        cost_type:'cost',
                    },
                    operator:'',
                    comparison_type:'',
                    comparison_value:undefined,
                    same_time_segment:'0',
                },
                conditionVerifyInfo:{},
            }
        },
        computed:{
            maxNum(){
                return this.max_num();
            },
            curConNum(){
                return JSON.stringify(this.formData.conditions).split('cid').length-1;
            },
        },
        mounted(){
            this.setFirstCondition();
        },
        methods:{
            setFormData(data){
                this.formData.conditions =  JSON.parse(data.conditions);
                if(this.isEdit||this.isCopy){
                    this.$nextTick(()=>{
                        this.$store.commit('intelligent/UPDATE_CONDITIONS_KPI');
                    })
                }
            },
            setFirstCondition(){
                let firstId = utils.randomString(12);
                let newCondition = cloneDeep(this.baseCondition);
                newCondition.cid = utils.randomString(12);
                newCondition.logicId = firstId;
                this.formData.conditions = {
                    logic:'且',
                    condition:newCondition,
                    logicId:firstId,
                    depth:1,
                };
            },
            handleValidate(key, valid, info){
                const data = {
                    condition: '条件-条件',
                };
                if (!valid) {
                    this.validFormItem(`${data[key]}：${info}`);
                }
            },
            getComparativeValueConfig(data,val){
                console.log('getComparativeValueConfig',data,val);
                let actionData = this._findConModuleById(this.formData.conditions,data.cid);
                let actionItem = null;
                if(Array.isArray(actionData.data)){
                    actionItem = actionData.data.find(item=>item.cid==data.cid);
                }else{
                    actionItem = actionData.data;
                }

                this.$set(actionItem,'textOptionLoading',true);
                API.getComparativeValueConfig({
                    plat_id:this.platId,
                    field:val,
                }).then(res=>{
                    this.$set(actionItem,'textOptionList',res.data||[]);
                    this.$set(actionItem,'textOptionLoading',false);
                },err=>{
                    console.log('getComparativeValueConfig err',err);
                    this.$set(actionItem,'textOptionList',[]);
                    this.$set(actionItem,'textOptionLoading',false);
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
            },
            addCondition(data,type){
                if(this.curConNum>=this.maxNum) return this.$message.error('最多添加'+this.maxNum+'个条件');

                let condition = data.condition;
                let newCondition = cloneDeep(this.baseCondition);
                newCondition.cid = utils.randomString(12);

                if(type=='current'){
                    newCondition.logicId = data.logicId;
                    /* 添加同级 */
                    if(Array.isArray(condition)){
                        condition.push(newCondition);
                    }else{
                        let oldCondition = cloneDeep(data.condition);
                        this.$set(data,'condition',[oldCondition].concat(newCondition));
                    }
                }else if(type=='child'){
                    /* 添加下级 */
                    if(Array.isArray(condition)){
                         console.log(2.1,condition);
                         if(condition.some(item=>item.logic)){
                             return this.$message.error('已经有下级了，不能再添加了');
                         }else{
                             let newId = utils.randomString(12);
                             newCondition.logicId = newId;
                             condition.push({
                                 logic:'且',
                                 condition:newCondition,
                                 logicId:newId,
                                 depth:data.depth+1,
                             });
                         }
                    }else{
                        let oldCondition = cloneDeep(data.condition);
                        console.log('添加下级1',data,oldCondition);
                        this.$set(data,'condition',[oldCondition].concat({
                            condition:newCondition,
                            logic:'且',
                            logicId:utils.randomString(12),
                            depth:data.depth+1,
                        }));
                    }
                }
            },
            toggleLogic(data){
                data.logic = data.logic=='且'?'或':'且';
            },
            removeCondition(data){
                console.log('removeCondition2 data',data);
                if(this.curConNum==1) return this.$message.error('至少要保留1个条件');

                let module = this._findConModuleById(this.formData.conditions.condition,data.cid, this.formData.conditions);
                if(Array.isArray(module.data)&&module.data.length==2&&module.data.filter(item=>item.condition).length==1){
                    return this.$message.error('删除失败：同级条件包含下级，无法删除');
                }

                if (Array.isArray(module.data)) {
                    const i = module.data.findIndex(v=> v.cid === data.cid);
                    module.data.splice(i, 1);
                    if (module.data.length === 1) {
                        this.$set(module.pData, 'condition', module.data[0])
                    }
                }else {
                    let logicId = module.pData.logicId
                    let logicModule = this._findLogicModuleById(this.formData.conditions.condition,logicId, this.formData.conditions);
                    console.log(logicModule);
                    if (!Array.isArray(logicModule.data)) {
                        logicId = logicModule.pData.logicId
                        logicModule = this._findLogicModuleById(this.formData.conditions.condition,logicId, this.formData.conditions);
                    }
                    const i = logicModule.data.findIndex(v=> v.logicId === logicId);
                    console.log(i, logicId);
                    logicModule.data.splice(i, 1);
                    if (logicModule.data.length === 1) {
                        this.$set(logicModule.pData, 'condition', logicModule.data[0])
                    }
                }
            },
            _findConModuleById(data,id, pData){
                if (Array.isArray(data)) {
                    const ids = data.map(v=>v.cid );
                    if (ids.includes(id))  {
                        return {
                            data,
                            pData
                        }
                    }else {
                        for (let i = 0; i < data.length; i++) {
                            const list = data[i].condition&&this._findConModuleById(data[i].condition, id, data[i]);
                            if (list) {
                                return list
                            }
                        }
                    }
                }else {
                    if (data?.cid === id) {
                        return {
                            data,
                            pData
                        }
                    }else {
                        if (data.condition) {
                            const info = this._findConModuleById(data.condition, id, data)
                            return info;
                        }
                    }
                }
            },
            _findLogicModuleById(data,id, pData){
                if (Array.isArray(data)) {
                    const ids = data.map(v=>v.logicId );
                    if (ids.includes(id))  {
                        return {
                            data,
                            pData
                        }
                    }else {
                        for (let i = 0; i < data.length; i++) {
                            const list = data[i].condition&&this._findLogicModuleById(data[i].condition, id, data[i]);
                            if (list) {
                                return list
                            }
                        }
                    }
                }else {
                    if (data?.logicId === id) {
                        return {
                            data,
                            pData
                        }
                    }else {
                        if (data.condition) {
                            const info = this._findLogicModuleById(data.condition, id, data)
                            return info;
                        }
                    }
                }
            },
            changeConItem(data,type,val,id,conditionType){
                let actionData = this._findConModuleById(this.formData.conditions,data.cid);
                let actionItem = {};
                if(Array.isArray(actionData.data)){
                    actionItem = actionData.data.find(item=>item.cid==data.cid);
                }else{
                    actionItem = actionData.data;
                }

                if(type=='monitor_data.field'){
                    actionItem.monitor_data.field = val;
                    actionItem.monitor_data.id = id;
                    actionItem.monitor_data.condition_type = conditionType;

                    // 清空下面的值
                    actionItem.monitor_data.range_time_type = '';
                    actionItem.monitor_data.range_time_n = undefined;
                    actionItem.monitor_data.range_time_n1 = undefined;
                    actionItem.monitor_data.range_time = [];
                    actionItem.monitor_data.data_method = '';

                    actionItem.comparative_data.id = '';
                    actionItem.comparative_data.field = '';
                    actionItem.comparative_data.condition_type = '';
                    actionItem.comparative_data.range_time_type = '';
                    actionItem.comparative_data.range_time_n = undefined;
                    actionItem.comparative_data.range_time_n1 = undefined;
                    actionItem.comparative_data.range_time = [];
                    actionItem.comparative_data.data_method = '';
                    actionItem.comparative_data.delivery_scene = '';
                    actionItem.operator = '';
                    actionItem.comparison_type = '';
                    actionItem.comparison_value = undefined;
                    actionItem.same_time_segment = '0';
                }else if(type=='monitor_data.range_time_type'){
                    actionItem.monitor_data.range_time_type = val;
                    actionItem.monitor_data.range_time = [];
                    actionItem.monitor_data.data_method = '';
                    actionItem.monitor_data.range_time_n = undefined;
                    actionItem.monitor_data.range_time_n1 = undefined;
                    actionItem.operator = '';
                    actionItem.comparative_data.id = '';
                    actionItem.comparative_data.field = '';
                    actionItem.comparative_data.condition_type = '';
                    actionItem.comparative_data.range_time_type = '';
                    actionItem.comparative_data.range_time_n = undefined;
                    actionItem.comparative_data.range_time_n1 = undefined;
                    actionItem.comparative_data.range_time = [];
                    actionItem.comparative_data.data_method = '';
                    actionItem.comparative_data.delivery_scene = '';
                    actionItem.operator = '';
                    actionItem.comparison_type = '';
                    actionItem.comparison_value = undefined;

                    if(val=='1'){
                        actionItem.monitor_data.range_time = [];
                        /*当监控项的时间范围选中当日，且对比项选中一类数值，在对比值的后方显示【同时段】选项，并且选中。*/
                        if(actionItem.monitor_data.condition_type=='data_1'&&actionItem.comparative_data.condition_type=='data_1'){
                            actionItem.same_time_segment = '1';
                        }else{
                            actionItem.same_time_segment = '0';
                        }
                    }else if(val == '2'){
                        actionItem.monitor_data.range_time.length = 1;
                        actionItem.same_time_segment = '0';
                        if(!actionItem.monitor_data.range_time_n){
                            actionItem.comparative_data.field = '';
                        }
                    }else if(val=='5'||val=='6'){
                        actionItem.monitor_data.range_time = [];
                    }else if(val=='4'){
                        actionItem.monitor_data.range_time.length = 1;
                    }
                    if(val=='1'||val=='2'){
                        actionItem.monitor_data.data_method = '1';       // 累计
                    }else{
                        actionItem.monitor_data.data_method = '';
                        actionItem.same_time_segment = '0';
                        if(!actionItem.monitor_data.range_time_n||!actionItem.monitor_data.range_time_n1){
                            actionItem.comparative_data.field = '';
                        }
                    }
                }else if(type=='monitor_data.range_time_n'){
                    actionItem.monitor_data.range_time_n = val>0?val:undefined;
                    actionItem.monitor_data.range_time[0] = val>0?val:undefined;
                }else if(type=='monitor_data.range_time_n1'){
                    actionItem.monitor_data.range_time_n1 = val>0?val:undefined;
                    actionItem.monitor_data.range_time[1] = val>0?val:undefined;
                }else if(type=='monitor_data.data_method'){
                    actionItem.monitor_data.data_method = val;
                    // 数据统计方式为【每日】，需要清除对比项
                    if(val=='3'){
                        actionItem.comparative_data.field = '-1';
                        actionItem.comparative_data.id = '-1';
                        actionItem.comparative_data.condition_type = '';
                        actionItem.comparison_type = '1';
                    }else{
                        actionItem.comparison_type = '';
                        if(actionItem.comparative_data.field=='-1'){
                            actionItem.comparative_data.field = '';
                            actionItem.comparative_data.id = '';
                        }
                    }
                }else if(type=='operator'){
                    actionItem.operator = val;
                }else if(type=='comparative_data.field'){
                    actionItem.comparative_data.field = val;
                    if(val=='-1'){
                        actionItem.comparative_data.id = val;
                    }else{
                        actionItem.comparative_data.id = id;
                    }
                    actionItem.comparative_data.condition_type = conditionType;

                    if(conditionType!='kpi_data'){
                        actionItem.comparative_data.delivery_scene = '';
                    }

                    // 清空下面的值
                    actionItem.comparative_data.range_time_type = '';
                    actionItem.comparative_data.range_time_n = undefined;
                    actionItem.comparative_data.range_time_n1 = undefined;
                    actionItem.comparative_data.range_time = [];
                    actionItem.comparative_data.data_method = '';
                    actionItem.comparison_type = val=='-1'?'1':'';
                    actionItem.comparison_value = undefined;

                    /*当监控项的时间范围选中当日，且对比项选中一类数值，在对比值的后方显示【同时段】选项，并且选中。*/
                    if(actionItem.monitor_data.range_time_type=='1'&&conditionType=='data_1'){
                        actionItem.same_time_segment = '1';
                    }else{
                        actionItem.same_time_segment = '0';
                    }

                }else if(type=='comparative_data.range_time_type'){
                    actionItem.comparative_data.range_time_type = val;
                    actionItem.comparative_data.range_time_n = undefined;
                    actionItem.comparative_data.range_time_n1 = undefined;
                    // 1-当日，2-前第N日，4-前第N日~当日，5-自然周~当日，6-自然月~当日
                    if(val=='1'||val=='5'||val=='6'){
                        actionItem.comparative_data.range_time = [];
                    }else if(val == '2'||val=='4'){
                        actionItem.comparative_data.range_time.length = 1;
                    }
                    if(val=='1'||val=='2'){
                        actionItem.comparative_data.data_method = '1';       // 累计
                    }else{
                        actionItem.comparative_data.data_method = '';
                    }
                }else if(type=='comparative_data.range_time_n'){
                    actionItem.comparative_data.range_time_n = val;
                    actionItem.comparative_data.range_time[0] = val;

                }else if(type=='comparative_data.range_time_n1'){
                    actionItem.comparative_data.range_time_n1 = val;
                    actionItem.comparative_data.range_time[1] = val;
                }else if(type=='comparative_data.delivery_scene'){
                    actionItem.comparative_data.delivery_scene = val;
                }else if(type=='comparative_data.data_method'){
                    actionItem.comparative_data.data_method = val;
                }else if(type=='comparison_type'){
                    this.$set(actionItem,'comparison_type',val);
                }else if(type=='comparison_value'){
                    this.$set(actionItem,'comparison_value',val>0||val===0?val:undefined);
                }else if(type=='same_time_segment'){
                    this.$set(actionItem,'same_time_segment',val);
                }else if(type=='check_api'){
                    let cid = data.cid;
                    if(Array.isArray(val.data)&&val.data.length<=0){
                        this.$set(this.conditionVerifyInfo,cid,{
                            isHasKPI:false,
                            kpiErrInfo:val.info||'请求异常',
                            err_app:[],
                            err_plan:[],
                        });
                        return false;
                    }
                    let resData = val.data||{};
                    let errApp = resData.err_app||[];
                    let errPlan = resData.err_plan||[];
                    let noApp = resData.no_app||[];
                    if(errApp.length<=0&&errPlan.length<=0&&noApp.length<=0){
                        this.$set(this.conditionVerifyInfo,cid,{
                            isHasKPI:true,
                            kpiErrInfo:'',
                            err_app:[],
                            err_plan:[],
                            no_app:[],
                        });
                        // this.conditionVerifyInfo[cid].isHasKPI = true;
                        // this.conditionVerifyInfo[cid].kpiErrInfo = '';
                        // this.conditionVerifyInfo[cid].err_app = [];
                        // this.conditionVerifyInfo[cid].err_plan = [];
                    }else{
                        this.$set(this.conditionVerifyInfo,cid,{
                            isHasKPI:false,
                            kpiErrInfo:val.info,
                            err_app:errApp,
                            err_plan:errPlan,
                            no_app:noApp,
                        });
                        // this.conditionVerifyInfo[cid].isHasKPI = false;
                        // this.conditionVerifyInfo[cid].kpiErrInfo = val.info;
                        // this.conditionVerifyInfo[cid].err_app = errApp;
                        // this.conditionVerifyInfo[cid].err_plan = errPlan;
                    }
                }else if(type=='monitor_data.cost_type'){
                    this.$set(actionItem.monitor_data,'cost_type',val);
                }else if(type=='comparative_data.cost_type'){
                    this.$set(actionItem.comparative_data,'cost_type',val);
                }
            },
            toKpiPage(){
                console.log('toKpiPage',this.errorKpiList);
                // let $router= this.$router.resolve({
                //     name:'app_kpi_'+this.plat_id,
                //     query:{
                //         app_id:this.kpiErrData,
                //     },
                // });
                // window.open($router.href, '_blank');
            },

            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();
                if (valid) {
                    return {...this.formData}
                }
            },

            _findModuleById(data,id){
                let condition = data.condition||{};
                if(Array.isArray(condition)){
                    for (let item in condition){
                        if(condition[item].condition&&condition[item].logic){
                            return this._findModuleById(condition[item],id);
                        }else{
                            if(condition[item].id==id){
                                return condition[item];
                            }
                        }
                    }
                }else{
                    if(condition.id = id){
                        return condition;
                    }
                }
            },
            getAllConditions(data){
                let result = [];
                if(data.cid){
                    result.push(data);
                }else if(data.condition){
                    if(Array.isArray(data.condition)){
                        let conList = data.condition;
                        conList.forEach(inner=>{
                            result = result.concat(this.getAllConditions(inner))
                        })
                    }else{
                        result = result.concat(this.getAllConditions(data.condition))
                    }
                }
                return result;
            },
            checkConditionError(data){
                let monitorData = data.monitor_data||{};
                let comparativeData = data.comparative_data||{};
                let monitorConditionType = monitorData.condition_type;
                let comparativeConditionType = comparativeData.condition_type;


                if(!monitorData.field) return '监控项不可为空';

                if(monitorConditionType=='data_1'){
                    if(!monitorData.range_time_type) return '监控项时间范围不可为空';

                    if((monitorData.range_time_type=='2'||monitorData.range_time_type=='3')&&!monitorData.range_time_n) return '监控项时间范围有误';
                    if(monitorData.range_time_type=='3'&&!monitorData.range_time_n1) return '监控项时间范围有误';
                    if(!monitorData.data_method) return '监控项数据统计方式不可为空';


                    if(!comparativeData.field) return '对比项不可为空';
                    if(comparativeConditionType=='data_1'){

                        // 对比项时间范围没有填写天数
                        if((comparativeData.range_time_type=='2'||comparativeData.range_time_type=='3')&&!comparativeData.range_time_n) return '对比项时间范围有误';
                        if(comparativeData.range_time_type=='3'&&!comparativeData.range_time_n1) return '对比项时间范围有误';
                        if(!comparativeData.data_method) return '对比项数据统计方式不可为空';      //
                        if(!data.comparison_type) return '对比类型不可为空';
                    }else if(comparativeConditionType=='data_2'){
                        if(!comparativeData.field) return '对比项不可为空';
                        if(!data.comparison_type) return '对比类型不可为空';
                    }
                }else if(monitorConditionType=='data_2'){
                    if(!data.comparison_type) return '对比类型不可为空';
                }

                if(!data.operator) return '运算符不可为空';

                // 没有对比值
                if(!data.comparison_value||(Array.isArray(data.comparison_value)&&data.comparison_value.length<=0)){
                    return false;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
